import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FaArrowRight, FaSlidersH, FaLightbulb } from 'react-icons/fa';
import './input.css';

/* ====================== MODELOS ====================== */
const MODELS = [
  'Conductual básico',
  'Conductual avanzado',
  'Neuroconductual básico',
  'Neuroconductual avanzado',
  'Neuroconductual profundo'
];

/* ====================== PREGUNTAS ====================== */
const QUESTIONS_BY_MODEL = {
  'Conductual básico': [
    '¿Cómo regular impulsos?', '¿Qué bloquea la escucha?', '¿Cómo ordenar prioridades?',
    '¿Qué activa la empatía?', '¿Cómo bajar la tensión?', '¿Qué sesgos influyen aquí?',
    '¿Cómo sostener acuerdos?', '¿Qué frena la cooperación?', '¿Cómo abrir al cambio?',
    '¿Qué marca la confianza?', '¿Cómo resolver conflictos?', '¿Qué pauta la comunicación?',
    '¿Cómo asignar los roles?', '¿Qué dispara resistencia?', '¿Cómo cuidar los límites?',
    '¿Qué estabiliza el grupo?', '¿Cómo alinear intereses?', '¿Qué define la negociación?',
    '¿Cómo desescalar choques?', '¿Qué hábitos unen más?', '¿Cómo aclarar objetivos?',
    '¿Qué señales de retraer?', '¿Cómo moderar lo competitivo?', '¿Qué favorece la escucha?',
    '¿Cómo elegir criterios?', '¿Qué guía decisiones?', '¿Cómo mantener foco?',
    '¿Qué patrones de tensión?', '¿Cómo reforzar vínculos?', '¿Qué abre la cooperación?'
  ],
  'Conductual avanzado': [
    '¿Cómo unir normas y valores?', '¿Qué anticipa resistencia?', '¿Cómo balancear control?',
    '¿Qué pasa bajo presión?', '¿Cómo afinar la escucha?', '¿Qué erosiona resiliencia?',
    '¿Cómo probar cooperación?', '¿Qué liderazgos emergen?', '¿Cómo ordenar adentro?',
    '¿Qué filtra la memoria?', '¿Cómo ajustar expectativas?', '¿Qué sostiene la ética?',
    '¿Cómo canalizar creatividad?', '¿Qué evidencia confianza?', '¿Cómo gestionar escasez?',
    '¿Qué delimita el poder?', '¿Cómo balancear riesgo?', '¿Qué modera frustración?',
    '¿Cómo leer tensiones?', '¿Qué define claridad?', '¿Cómo alinear metas?',
    '¿Qué anticipa desconexión?', '¿Cómo sostener compromisos?', '¿Qué orienta lo racional?',
    '¿Cómo detectar sesgos?', '¿Qué cuida autonomía?', '¿Cómo navegar ambigüedad?',
    '¿Qué impulsa motivación?', '¿Cómo reforzar disciplina?', '¿Qué limita cooperación?'
  ],
  'Neuroconductual básico': [
    '¿Cómo evaluar riesgos?', '¿Qué refuerza decisiones?', '¿Cómo activar motivación?',
    '¿Qué facilita innovación?', '¿Cómo repartir atención?', '¿Qué modera frustración?',
    '¿Cómo procesar ambigüedad?', '¿Qué sostiene disciplina?', '¿Cómo equilibrar emoción?',
    '¿Qué sesgos de percepción?', '¿Cómo fijar memoria grupal?', '¿Qué anticipa el error?',
    '¿Cómo modular el estrés?', '¿Qué activa confianza?', '¿Cómo leer ambigüedad?',
    '¿Qué guía creatividad?', '¿Cómo coordinar esfuerzo?', '¿Qué limita cooperación?',
    '¿Cómo ajustar lo cognitivo?', '¿Qué predice el éxito?', '¿Cómo evaluar estímulos?',
    '¿Qué mejora regulación?', '¿Cómo combinar señales?', '¿Qué sesgos grupales hay?',
    '¿Cómo fijar aprendizaje?', '¿Qué sostiene autocontrol?', '¿Cómo reordenar claves?',
    '¿Qué guía la confianza?', '¿Cómo elegir criterios?', '¿Qué potencia memoria?'
  ],
  'Neuroconductual avanzado': [
    '¿Cómo diferenciar roles?', '¿Qué regula cooperación?', '¿Cómo dosificar energía?',
    '¿Qué dispara creatividad?', '¿Cómo formar sentido común?', '¿Qué guía la atención?',
    '¿Cómo ordenar memoria?', '¿Qué sostiene confianza?', '¿Cómo leer tensiones?',
    '¿Qué define lo esencial?', '¿Cómo adaptar patrones?', '¿Qué anticipa saturación?',
    '¿Cómo dosificar esfuerzo?', '¿Qué sostiene resiliencia?', '¿Cómo equilibrar polos?',
    '¿Qué anticipa bloqueos?', '¿Cómo guiar el flujo atencional?', '¿Qué fortalece flexibilidad?',
    '¿Cómo medir congruencia?', '¿Qué refleja estabilidad?', '¿Cómo alinear memorias?',
    '¿Qué sesgos en proceso?', '¿Cómo mitigar fatiga?', '¿Qué guía exploración?',
    '¿Cómo reforzar disciplina?', '¿Qué define claridad?', '¿Cómo ajustar roles?',
    '¿Qué sostiene regulación?', '¿Cómo aterrizar innovación?', '¿Qué marca disociación?'
  ],
  'Neuroconductual profundo': [
    '¿Cómo leer rasgos depresivos?', '¿Qué anticipa ideación grave?', '¿Cómo detectar ansiedad?',
    '¿Qué marca riesgo de ira?', '¿Cómo leer rasgos psicóticos?', '¿Qué indica disociación?',
    '¿Cómo anticipar consumos?', '¿Qué muestra somatización?', '¿Cómo notar déficit de sueño?',
    '¿Qué refleja pérdida del yo?', '¿Cómo ver delirios iniciales?', '¿Qué intensifica ansiedad?',
    '¿Cómo leer defensas primitivas?', '¿Qué predice episodios?', '¿Cómo ver rasgos maníacos?',
    '¿Qué refleja disforia?', '¿Cómo anticipar recaídas?', '¿Qué pauta obsesividad?',
    '¿Cómo ver evitación?', '¿Qué predice compulsiones?', '¿Cómo leer fragmentación?',
    '¿Qué anticipa ideación?', '¿Cómo ver síntomas somáticos?', '¿Qué revela disociación leve?',
    '¿Cómo leer cambios cognitivos?', '¿Qué refuerza delirios?', '¿Cómo ver crisis de identidad?',
    '¿Qué evidencia psicosis latente?', '¿Cómo notar pérdidas mnésicas?', '¿Qué anticipa colapso yoico?'
  ]
};

/* ====================== HELPERS PERSONA ====================== */
const addSuffixBeforeQM = (q, suffix) => {
  const i = q.lastIndexOf('?');
  return i === -1 ? `${q} ${suffix}` : `${q.slice(0, i)} ${suffix}${q.slice(i)}`;
};

const toFirstPerson = (q) => {
  if (q.startsWith('¿Cómo se ')) {
    const rest = q.slice('¿Cómo se '.length);
    const firstSwap = rest.replace(/\bse\b/i, 'me');
    return addSuffixBeforeQM(`¿Cómo me ${firstSwap}`, 'en mi caso');
  }
  if (q.startsWith('¿Qué ')) return addSuffixBeforeQM(q, 'en mi caso');
  return addSuffixBeforeQM(q.replace(/\b se \b/gi, ' me '), 'en mi caso');
};

const forcePersonLabel = (u) => {
  if (u == null) return '(sin nombre)';
  if (typeof u === 'string') return u.trim() || '(sin nombre)';
  if (typeof u === 'object') {
    const fields = ['label','name','full_name','fullName','displayName','nombre','alias','username'];
    for (const k of fields) if (typeof u[k] === 'string' && u[k].trim()) return u[k].trim();
    const combos = [['firstName','lastName'],['nombre','apellido'],['given_name','family_name']];
    for (const [a,b] of combos) {
      if (typeof u[a] === 'string' && u[a].trim() && typeof u[b] === 'string' && u[b].trim()) {
        return `${u[a].trim()} ${u[b].trim()}`;
      }
    }
    for (const v of Object.values(u)) if (typeof v === 'string' && v.trim()) return v.trim();
    try {
      const mini = {}; for (const k of Object.keys(u).slice(0,5)) mini[k] = u[k];
      return JSON.stringify(mini);
    } catch { return String(u); }
  }
  return String(u);
};

const toThirdPerson = (q, userLike) => addSuffixBeforeQM(q, `en ${forcePersonLabel(userLike)}`);

/* ====================== UI (SUGERENCIAS) ====================== */
const computeSuggestionUI = () => {
  const w = typeof window !== 'undefined' ? window.innerWidth : 1280;
  const isMobile = w <= 640;
  const isTablet = w > 640 && w <= 900;
  const isDesktop = w > 900;

  return {
    isMobile, isTablet, isDesktop,
    visibleCount: 3,
    styles: {
      container: { position: 'relative', marginBottom: 8, zIndex: 2 },
      chipsRow: {
        display: isDesktop || isTablet ? 'flex' : 'none',
        justifyContent: 'center',
        gap: isTablet ? 6 : 8,
        flexWrap: 'wrap'
      },
      chip: {
        fontSize: isTablet ? '0.72rem' : '0.75rem',
        fontWeight: 300,
        padding: isTablet ? '4px 6px' : '4px 8px',
        border: '1px solid #ccc',
        borderRadius: 8,
        background: '#f9f9f9',
        cursor: 'pointer',
        lineHeight: 1.2,
        maxWidth: 330
      },
      mobileTrigger: {
        display: isMobile ? 'flex' : 'none',
        alignItems: 'center',
        gap: 8,
        position: 'relative',
        width: 'fit-content',
        margin: '0 auto 6px auto',
        padding: '6px 10px',
        borderRadius: 999,
        border: '1px solid #e5e7eb',
        background: '#ffffffcc',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      },
      triggerIconWrap: {
        width: 28, height: 28, borderRadius: 999,
        display: 'grid', placeItems: 'center',
        border: '1px solid #e5e7eb', background: '#fff'
      },
      triggerText: { fontSize: '0.85rem' },
      mobilePanelRow: { display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }
    }
  };
};

/* ========== PORTAL (panel mobile) ========== */
const MobileSuggestionsPortal = ({ open, children, onPanelMount }) => {
  const mountRef = React.useRef(null);

  if (!mountRef.current && typeof document !== 'undefined') {
    mountRef.current = document.createElement('div');
  }

  useEffect(() => {
    if (!mountRef.current) return;
    const el = mountRef.current;
    el.style.position = 'fixed';
    el.style.inset = '0';
    // Contenedor no captura clicks cuando no hay panel
    el.style.pointerEvents = 'none';
    el.style.zIndex = '2147483647';
    document.body.appendChild(el);
    return () => { document.body.removeChild(el); };
  }, []);

  // interceptamos el nodo del panel para medir altura
  const wrapped = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return child;
    if (child.props?.['data-panel-root']) {
      return React.cloneElement(child, {
        ref: (node) => {
          if (node && onPanelMount) {
            requestAnimationFrame(() => {
              onPanelMount(node, node.getBoundingClientRect().height);
            });
          }
        }
      });
    }
    return child;
  });

  if (!open || !mountRef.current) return null;
  return createPortal(wrapped, mountRef.current);
};

/* ====================== COMPONENTE PRINCIPAL ====================== */
const InputComponent = ({
  messageInput,
  setMessageInput,
  handleKeyDown,
  sendMessage,
  isStreaming,
  selectedModel,
  setSelectedModel,
  selectedUser
}) => {
  const descriptionRef = useRef(null);

  const [uiProps, setUiProps] = useState(computeSuggestionUI());
  const [mobilePanelOpen, setMobilePanelOpen] = useState(false);
  const [panelHeight, setPanelHeight] = useState(0);
  const [panelNode, setPanelNode] = useState(null);
  const triggerRef = useRef(null);

  const [displayedSuggestions, setDisplayedSuggestions] = useState([]);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [menuAnchorRect, setMenuAnchorRect] = useState(null);

  const [isSidebarOpen, setSidebarOpen] = useState(false);

  // <- NUEVO: observar cambios de tamaño del panel (para empuje del trigger)
  useEffect(() => {
    if (!panelNode) return;
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const h = entry.contentRect.height;
        setPanelHeight(h);
      }
    });
    ro.observe(panelNode);
    return () => ro.disconnect();
  }, [panelNode]);

  useEffect(() => {
    const onResize = () => setUiProps(computeSuggestionUI());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (descriptionRef.current) {
      descriptionRef.current.style.height = 'auto';
      descriptionRef.current.style.height = `${descriptionRef.current.scrollHeight}px`;
    }
  }, [messageInput]);

  const randomizeSuggestions = () => {
    const list = QUESTIONS_BY_MODEL[selectedModel] || [];
    const shuffled = list.slice().sort(() => Math.random() - 0.5);
    setDisplayedSuggestions(shuffled.slice(0, uiProps.visibleCount));
    setOpenMenuIndex(null);
  };

  useEffect(() => {
    randomizeSuggestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModel, uiProps.visibleCount]);

  const handleSuggestionClick = (btnEl, q, idx) => {
    if (btnEl) {
      if (uiProps.isMobile && panelNode) {
        // Coordenadas relativas al panel (el menú será absolute respecto al panel)
        const panelRect = panelNode.getBoundingClientRect();
        const btnRect = btnEl.getBoundingClientRect();
        setMenuAnchorRect({
          top: btnRect.bottom - panelRect.top + panelNode.scrollTop,
          left: btnRect.left - panelRect.left + panelNode.scrollLeft,
          width: btnRect.width
        });
      } else {
        const rect = btnEl.getBoundingClientRect();
        setMenuAnchorRect({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
          width: rect.width
        });
      }
    }
    setOpenMenuIndex(prev => (prev === idx ? null : idx));
  };

  const choosePerspective = (neutral, perspective) => {
    const text =
      perspective === 'first'
        ? toFirstPerson(neutral)
        : perspective === 'third'
          ? toThirdPerson(neutral, selectedUser.nombres)
          : neutral;

    setMessageInput(text);
    setOpenMenuIndex(null);
    // si lo deseas, podrías mantener el panel abierto; por ahora cerramos
    setMobilePanelOpen(false);
    if (descriptionRef.current) descriptionRef.current.focus();
  };

  const toggleSidebar = () => setSidebarOpen(o => !o);
  const handleModelClick = (model) => {
    setSelectedModel(model);
    setSidebarOpen(false);
  };

  const handleSendWrapped = () => {
    if (typeof sendMessage === 'function') sendMessage();
    randomizeSuggestions();
  };

  const handleKeyDownWrapped = (e) => {
    if (typeof handleKeyDown === 'function') handleKeyDown(e);
  };

  useEffect(() => {
    const onDocClick = (e) => {
      if (!e.target.closest('.suggestion-box') && !e.target.closest('.suggestion-menu')) {
        setOpenMenuIndex(null);
      }
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  // <- NUEVO: cuando el menú está abierto en mobile, queremos que el panel se agrande y no haga scroll interno
  const panelGrow = uiProps.isMobile && mobilePanelOpen && openMenuIndex !== null;

  return (
    <div className="input-wrapper" style={{ position: 'relative', zIndex: 1 }}>
      {/* ======= SUGERENCIAS ======= */}
      <div style={uiProps.styles.container}>
        {/* Trigger Mobile */}
        <button
          type="button"
          ref={triggerRef}
          onClick={() => setMobilePanelOpen(v => !v)}
          style={{
            ...uiProps.styles.mobileTrigger,
            transform: mobilePanelOpen
              ? `translateY(-${Math.min(
                  (panelHeight || 0) + 12,
                  Math.round((typeof window !== 'undefined' ? window.innerHeight : 800) * 0.85) + 12
                )}px)`
              : 'translateY(0)',
            transition: 'transform 180ms ease'
          }}
          aria-expanded={mobilePanelOpen}
          aria-controls="mobile-suggestions-panel"
        >
          <span style={uiProps.styles.triggerIconWrap}><FaLightbulb size={16} /></span>
          <span style={uiProps.styles.triggerText}>Sugerencias</span>
        </button>

        {/* Panel Mobile en portal */}
        <MobileSuggestionsPortal
          open={uiProps.isMobile && mobilePanelOpen}
          onPanelMount={(node, h) => { setPanelNode(node); setPanelHeight(h); }}
        >
          {/* Backdrop */}
          <div
            onClick={() => setMobilePanelOpen(false)}
            style={{
              position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.06)',
              pointerEvents: 'auto'
            }}
          />
          {/* Panel */}
          <div
            data-panel-root
            id="mobile-suggestions-panel"
            style={{
              position: 'fixed',
              left: '50%',
              transform: 'translateX(-50%)',
              bottom: 120,
              width: 'min(92vw, 560px)',
              // CLAVE: cuando hay menú abierto, el panel se agranda y no recorta
              maxHeight: panelGrow ? '85vh' : '65vh',
              overflow: panelGrow ? 'visible' : 'auto',
              background: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              boxShadow: '0 12px 24px rgba(0,0,0,0.14)',
              padding: 10,
              pointerEvents: 'auto'
            }}
          >
            {/* Contenido del panel */}
            <div style={{ fontSize: '0.78rem', marginBottom: 6, color: '#4b5563' }}>
              Elegí una sugerencia para reescribirla en 1ª o 3ª persona
            </div>
            <div
              className="mobile-suggestions-grid"
              style={{ ...uiProps.styles.mobilePanelRow /* sin position: 'relative' */ }}
            >
              {displayedSuggestions.map((q, idx) => (
                <button
                  key={`m-${idx}`}
                  type="button"
                  className="suggestion-box"
                  onClick={(e) => handleSuggestionClick(e.currentTarget, q, idx)}
                  style={uiProps.styles.chip}
                  aria-haspopup="menu"
                  aria-expanded={openMenuIndex === idx}
                >
                  {q}
                </button>
              ))}

              {/* Menú contextual MOBILE — absoluto respecto al PANEL */}
              {uiProps.isMobile && openMenuIndex !== null && menuAnchorRect && (
                <div
                  className="suggestion-menu"
                  role="menu"
                  style={{
                    position: 'absolute',
                    top: menuAnchorRect.top + 6,
                    left: menuAnchorRect.left,
                    background: '#fff',
                    border: '1px solid #ddd',
                    borderRadius: 8,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                    minWidth: Math.max(220, menuAnchorRect.width),
                    zIndex: 50,
                    padding: 6
                  }}
                >
                  <div style={{ fontSize: '0.72rem', padding: '6px 8px', color: '#555', borderBottom: '1px solid #eee' }}>
                    Elegí la perspectiva
                  </div>
                  <button
                    type="button"
                    role="menuitem"
                    onClick={() => choosePerspective(displayedSuggestions[openMenuIndex], 'first')}
                    style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '0.8rem' }}
                  >
                    Versión en primera persona
                  </button>
                  <button
                    type="button"
                    role="menuitem"
                    onClick={() => choosePerspective(displayedSuggestions[openMenuIndex], 'third')}
                    style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '0.8rem' }}
                  >
                    Versión en tercera persona
                  </button>
                </div>
              )}
            </div>
          </div>
        </MobileSuggestionsPortal>

        {/* Chips Desktop/Tablet */}
        <div className="suggestions-container" style={uiProps.styles.chipsRow}>
          {displayedSuggestions.map((q, idx) => (
            <button
              key={idx}
              type="button"
              className="suggestion-box"
              onClick={(e) => handleSuggestionClick(e.currentTarget, q, idx)}
              style={uiProps.styles.chip}
              aria-haspopup="menu"
              aria-expanded={openMenuIndex === idx}
            >
              {q}
            </button>
          ))}

          {/* Menú contextual Desktop/Tablet */}
          {openMenuIndex !== null && menuAnchorRect && !uiProps.isMobile && (
            <div
              className="suggestion-menu"
              role="menu"
              style={{
                position: 'absolute',
                top:
                  menuAnchorRect.top -
                  (document.querySelector('.suggestions-container')?.getBoundingClientRect().top ?? 0) - 8,
                left:
                  menuAnchorRect.left -
                  (document.querySelector('.suggestions-container')?.getBoundingClientRect().left ?? 0),
                background: '#fff',
                border: '1px solid #ddd',
                borderRadius: 8,
                boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                minWidth: Math.max(220, menuAnchorRect.width),
                zIndex: 30,
                padding: 6
              }}
            >
              <div style={{ fontSize: '0.72rem', padding: '6px 8px', color: '#555', borderBottom: '1px solid #eee' }}>
                Elegí la perspectiva
              </div>
              <button
                type="button"
                role="menuitem"
                onClick={() => choosePerspective(displayedSuggestions[openMenuIndex], 'first')}
                style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '0.8rem' }}
              >
                Versión en primera persona
              </button>
              <button
                type="button"
                role="menuitem"
                onClick={() => choosePerspective(displayedSuggestions[openMenuIndex], 'third')}
                style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '0.8rem' }}
              >
                Versión en tercera persona
              </button>
            </div>
          )}
        </div>
      </div>
      {/* ======= FIN SUGERENCIAS ======= */}

      <textarea
        ref={descriptionRef}
        placeholder="Hazme una pregunta conductual..."
        value={messageInput}
        onChange={e => setMessageInput(e.target.value)}
        onKeyDown={handleKeyDownWrapped}
        disabled={isStreaming}
        className="auto-resize-textarea-chat"
        rows={1}
      />
      <button onClick={handleSendWrapped} disabled={isStreaming} className="send-button">
        <FaArrowRight size={15} />
      </button>

      {/* Desktop select con icono */}
      <div className="desktop-select">
        <div className="select-with-icon">
          <FaSlidersH className="select-icon" size={16} />
          <select
            value={selectedModel}
            onChange={e => setSelectedModel(e.target.value)}
            className="modelo-select"
            disabled={isStreaming}
          >
            {MODELS.map(model => (
              <option key={model} value={model}>{model}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Botón filtro modelos (mobile) */}
      <button
        className="mobile-select-toggle"
        onClick={toggleSidebar}
        aria-label="Abrir modelos"
      >
        <FaSlidersH size={20} />
        <span className="selected-model-label">{selectedModel}</span>
      </button>

      {/* Drawer sidebar */}
      <div className={`model-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <button className="close-btn" onClick={toggleSidebar} aria-label="Cerrar">×</button>
        <ul className="model-list">
          {MODELS.map(model => (
            <li
              key={model}
              className={`model-item ${selectedModel === model ? 'selected' : ''}`}
              onClick={() => handleModelClick(model)}
            >
              {model}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default InputComponent;

